import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from '../../authentication/auth.service';
import { ApiServiceBase } from '../../base/api-service-base';
import { ActivityStatusReferenceModel } from '../../models/reference-model/reference-general-model/activity-status-reference.model';

@Injectable({
  providedIn: 'root'
})
export class ActivityStatusReferenceService extends ApiServiceBase {
  private readonly PATH = "/system/ActivityStatusReference";
  
  constructor(httpClient: HttpClient,
    authService: AuthService) {
    super(httpClient, authService);
  }

  public getActivityStatusReferences(): Observable<ActivityStatusReferenceModel[]> {
    return this.httpGet<ActivityStatusReferenceModel[]>(this.PATH, null)
      .pipe(
        map(response => response.body)
      );
  }
}
